import { rest, stdParamsSerializer } from "src/common/rest";
import { apiObjUrl } from "src/common/apiUrl";
import { ZUid } from "src/types/zUid";
import { ZPermissions } from "../roleTypes";

export const saveCopyOnAtts = async (
  stateId: ZUid,
  attributeIds: ZUid[],
  permissions: ZPermissions,
) =>
  rest.put(apiObjUrl("/permissions/copy-for-state"), permissions, {
    params: { stateId, attributeIds },
    paramsSerializer: stdParamsSerializer,
  });
